import { ResponseData } from "./tunnel-message-data";

/**
 * @hidden
 */
export interface ConfirmResponse extends ResponseData {
    type: '@stemcstudio/modal-dialog-service:confirm-response';
    value: boolean;
}

/**
 * @hidden
 */
export function isConfirmResponse(message: MessageEvent): message is MessageEvent<ConfirmResponse> {
    const duck = message as MessageEvent<ConfirmResponse>;
    if (duck.data.type && duck.data.type === '@stemcstudio/modal-dialog-service:confirm-response') {
        return true;
    } else {
        return false;
    }
}
